module.exports = __webpack_public_path__ + "img/foto-prueba.15905ebb.svg";